export default __webpack_public_path__ + "static/media/logo.d9d8b86c.png";